<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="广告位"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.updatesave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="广告位类型" prop="AdType">
              <el-select
                v-model="data.AdType"
                placeholder="请选择广告位类型"
                clearable
                disabled
              >
                <el-option label="资源广场" :value="1"></el-option>
                <el-option label="项目招商" :value="2"></el-option>
                <el-option label="用户风采" :value="3"></el-option>
                <el-option label="企业用户" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="广告位名称" prop="AdTitle">
              {{ data.AdTitle }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item> </el-col
        ></el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <person-dialog
      ref="personDialog"
      in-dialog
      selectable
      :multiple="true"
      @select="setPerson"
    />
    <resources-dialog
      ref="resourcesDialog"
      in-dialog
      selectable
      :multiple="true"
      @select="setPerson"
    />
    <project-dialog
      ref="projectDialog"
      in-dialog
      selectable
      :multiple="true"
      @select="setPerson"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import businessSelect from "@/components/shop/business/select";
import treeSelect from "@/components/common/treeSelect";
import personDialog from "@/components/person/personinfo/listDialogmul";
import resourcesDialog from "@/components/resources/detail/listDialogmul";
import projectDialog from "@/components/project/detail/listDialogmul";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    businessSelect,
    treeSelect,
    personDialog,
    resourcesDialog,
    projectDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        AdType: null,
        AdTitle: "",
        OrderId: 0,
        State: 1,
      },

      api: require("@/api/store/advertising").default,
      api2: require("@/api/goods/type").default,

      isMB: this.$store.state.isMB,
      rules: {
        //AdType: [{ required: true, message: "广告位类型不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
      tableData: [],
      selectData: [],
    };
  },
  methods: {
    getOption() {},
    addData() {
      var adType = this.data.AdType;
      if (!adType) {
        this.$message.error("请选择广告位类型");
        return false;
      }
      this.api.getIds(adType).then((res) => {
        if (adType == 1) {
          this.$refs.resourcesDialog.open().then((that) => {
            that.getData({ State: 2, NotInIds: res.Data });
          });
        } else if (adType == 2) {
          this.$refs.projectDialog.open().then((that) => {
            that.getData({ State: 2, NotInIds: res.Data });
          });
        } else if (adType == 3) {
          this.$refs.personDialog.open().then((that) => {
            that.getData({ State: 1, PersonType: 0, NotInIds: res.Data });
          });
        } else if (adType == 4) {
          this.$refs.personDialog.open().then((that) => {
            that.getData({ State: 1, PersonType: 1, NotInIds: res.Data });
          });
        }
      });
    },
    delData() {
      if (this.selectData.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.selectData.forEach((x) => {
        var index = this.tableData.indexOf(x);
        this.tableData.splice(index, 1);
      });
      //清空选中的数据
      this.selectData = [];
      //对序号进行重新排序
      this.tableData.forEach((x, i) => {
        x.Index = i;
        x.OrderId = i;
        if (x.RecordId != 0) {
          x.T = 1;
        } else {
          x.T = 0;
        }
      });
    },
    setPerson(t) {
      console.log(t, "setPerson");
      this.tableData = t.tableData;
    },
    onSelectData(selection) {
      this.selectData = selection;
    },
    onCreateOpened(row) {
      // this.getOption();
      // this.api.getMaxOrderId().then((res) => {
      //   if (res.Code == 0) this.data.OrderId = res.Data;
      // });
    },
    onEditOpened(row) {
      //this.getOption();
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));

      this.loading();
      this.api.updatesave(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>